const getAzureData = (state) => state?.search?.azureData || {};
const getB2CUpdateStatus = (state) => state?.search?.b2cUpdateStatus || null;
const getB2CUserData = (state) => state?.search?.b2cUserData || {};
const getBooking = (state) => state?.search?.data || [];
const getPassengerUpdateStatus = (state) => state?.search?.passengerUpdateStatus || null;

export { getAzureData, getB2CUpdateStatus, getB2CUserData, getBooking, getPassengerUpdateStatus };
